// card-gallery-pin.js
// Fix Safari: la product card mostra slide-1 al posto di slide-0 al load.
// Causa (già verificata a runtime, vedi md/analisi-pin-scroll.md §0): il flip
// asincrono overflow:hidden -> overflow-x:scroll innescato da [in-viewport]
// fa ri-snappare WebKit sullo slide sbagliato.
//
// Contromisura: un SOLO IntersectionObserver su `.card-gallery slideshow-component`.
// Al primo isIntersecting di ciascun componente con initial-slide==0, dopo il flip
// (schedulato in rAF), riportiamo lo scroller a scrollLeft=0 UNA SOLA VOLTA, poi
// marchiamo l'elemento e ne facciamo unobserve.
//
// Vincoli rispettati: niente loop/intervallo; non tocchiamo current/aria-hidden/slide;
// non modifichiamo slideshow.js. No-op dove scrollLeft è già 0 (Chrome/FF/Android).

(() => {
  const SELECTOR = ".card-gallery slideshow-component";

  /**
   * Riporta lo scroller del componente a sinistra (slide-0), una sola volta.
   * @param {Element} comp - lo slideshow-component dentro una .card-gallery
   */
  const pin = (comp) => {
    if (comp.dataset.cgPinned != null) return;
    // Doppia guardia: solo galleries che partono dallo slide 0.
    if (comp.getAttribute("initial-slide") !== "0") return;

    requestAnimationFrame(() => {
      const sc = comp.querySelector("slideshow-slides");
      if (sc) {
        sc.scrollTo({ left: 0, behavior: "instant" });
        sc.scrollLeft = 0;
      }
    });

    comp.dataset.cgPinned = "";
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const comp = entry.target;
        pin(comp);
        observer.unobserve(comp);
      }
    },
    { rootMargin: "100px" }
  );

  const observeAll = (root = document) => {
    for (const comp of root.querySelectorAll(SELECTOR)) {
      if (comp.dataset.cgPinned == null) observer.observe(comp);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => observeAll(), {
      once: true,
    });
  } else {
    observeAll();
  }
})();
